import { render, staticRenderFns } from "./ReviewImageLightbox.vue?vue&type=template&id=087a4e54&scoped=true&"
import script from "./ReviewImageLightbox.vue?vue&type=script&lang=js&"
export * from "./ReviewImageLightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a4e54",
  null
  
)

export default component.exports